export default {
  computed: {
    placeholderNode: function placeholderNode() {
      return this.renderPlaceholderNode();
    }
  },
  methods: {
    renderPlaceholderNode: function renderPlaceholderNode() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          placeholder = this.placeholder,
          searchInputValue = this.searchInputValue;
      return !searchInputValue && placeholder ? h("span", {
        "key": "placeholder",
        "class": "".concat(prefixCls, "-selection__placeholder")
      }, [placeholder]) : null;
    }
  }
};